
// src/web/components/animation-css.js

import React from 'react'
import { css } from 'glamor'

export default function(animate, opts = {}) {
  const {
    from = { opacity: 1 },
    to = { opacity: 0.3 },
    duration = '1.5s',
    delay = 0,
    iterationCount = 'infinite',
  } = opts

  if (!animate)
    return undefined

  return css({
    animationName: `${css.keyframes({ '0%, 100%': from, '50%': to, })}`,
    animationDuration: duration,
    animationDelay: delay,
    animationIterationCount: iterationCount,
  })
}



// WEBPACK FOOTER //
// ./src/web/components/animation-css.js